/**
 * Formatteurs génériques pour les tables
 */
var BsTableColumnsFormatters = {

    dateTimeFormatter: function(value) {
        return moment(value).format('DD/MM/YYYY HH:mm');
    },

    dateTimeFormatterShort: function(value) {
        if (value) {
            return moment(value).format('DD/MM/YY HH:mm');
        }
        return null;
    },

    dateFormatter: function(value) {
        if (value && value != '0000-00-00') {
            return moment(value).format('DD/MM/YYYY');
        }
        return '-';
    },

    dateFormatterShort: function(value) {
        if (value && value != '0000-00-00') {
            return moment(value).format('DD/MM/YY');
        }
        return '-';
    },

    moneyFormatter: function(value) {
        return parseFloat(value).toFixed(2).replace(".", ",") + '&nbsp;€';
    },

    floatFormatter: function(value) {
        return parseFloat(value).toFixed(2).replace(".", ",");
    },

    pictureFormatter: function(value, row) {
        if(value) {
            var images = value.split(';');
            var i = 0;
            value = '';
            $.each(images, function (index, url){
                i++;
                value += '<a href="'+url+'" data-toggle="lightbox" data-gallery="'+row.refBien+'" '+((i>1)?'style="display:none;"':'')+'><i class="fas fa-camera fa-2x"></i></a>';
            });
        }
        return value;
    },

    singlePictureFormatter: function(value, row) {
        if(value) {
            var images = value.split(';');
            var i = 0;
            value = '';
            if(images.length > 0) {
                value = '<a href="'+images[0]+'" data-toggle="lightbox"><img data-src="'+images[0]+'" data-toggle="lightbox" loading="lazy" class="lazy"/></a>'
            }
        }
        return value;
    }

};
